var $cache = {
    window: $(window),
    body: $('body'),
    menuSidebar : $('.js-menu-sidebar'),
};

$cache.headerBanner = $cache.body.find('.header-banner');
$cache.playAnimationButton = $cache.body.find('.play-animation-button');


// reset hide_header_banner after each load
window.sessionStorage.setItem('hide_header_banner', '');

var headerBannerStatus =
    window.sessionStorage.getItem('hide_header_banner');
$cache.headerBanner.find('.icon-banner-close').on('click', function () {
    $cache.headerBanner.addClass('d-none');
    window.sessionStorage.setItem('hide_header_banner', '1');
});
function toggleButtons() {
    $cache.headerBanner
        .find(
            '.play-animation-button, .header-banner .pause-animation-button'
        )
        .toggle();
}
var isAnimationPlaying = true;

$cache.headerBanner.on('click', '.play-animation-button', function () {
    if (!isAnimationPlaying) {
        $cache.headerBanner.find('#carousel-header').removeClass('paused').carousel('cycle');
        isAnimationPlaying = true;
        toggleButtons();
    }
});

$cache.headerBanner.on('click', '.pause-animation-button', function () {
    if (isAnimationPlaying) {
        $cache.headerBanner.find('#carousel-header').addClass('paused').carousel('pause');;
        isAnimationPlaying = false;
        toggleButtons();
    }
});
// Initially, show the stop button and hide the play button
$cache.playAnimationButton.hide();
if (!headerBannerStatus || headerBannerStatus < 0) {
    $cache.headerBanner.removeClass('d-none');
}


// Menu Mobile 
$cache.menuSidebar.on('click', '.nav-item', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var $this = $(this);
    if ($this.find('.sub-nav-item').length > 0) {
        $this.addClass('show');
        $cache.menuSidebar.find('.back-button').attr('data-index', $this.data('index'));
        $cache.menuSidebar.find('.back-button').removeClass('hide');
        $cache.menuSidebar.find('.category-name a').text($this.find('> a').text());
        $cache.menuSidebar.find('.category-name a').attr('href', $this.find('> a').attr('href'));
    } else {
        window.location.href = $this.find('> a').attr('href');
    }
})
$cache.menuSidebar.on('click', '.back-button', function (e) {
    var $this = $(this);
    var index =  $this.attr('data-index');
    $cache.menuSidebar.find(`.nav-item.show[data-index="${index}"]`).removeClass('show');
    var newIndex = parseInt(index, 10) - 1;
    $this.attr('data-index', newIndex);
    if (newIndex === 0) {
        $this.addClass('hide');
        $cache.menuSidebar.find('.category-name a').text('');
    } else {
        $this.removeClass('hide');
        $cache.menuSidebar.find('.category-name a')
        .text($cache.menuSidebar.find(`.nav-item.show[data-index="${newIndex}"] > a`).text());
        $cache.menuSidebar.find('.category-name a')
        .attr('href', $cache.menuSidebar.find(`.nav-item.show[data-index="${newIndex}"] > a`).attr('href'));
    }
})
